import React from 'react';
import { observer } from 'mobx-react-lite';

import globalStore from 'src/stores/global-store';

import { LOCALES } from 'src/constants';

const CheckoutInfo = observer(() => {
  const { cemeteryName, decedent, deceasedYearsLife, location } = globalStore;

  return (
    <div className="checkout-page__receipt-block">
      <div className="checkout-page__receipt-title">{cemeteryName}</div>
      <div className="checkout-page__receipt-content">
        <div className="checkout-page__receipt-info">
          <span className="checkout-page__receipt-info-title">{LOCALES.DECEDENT}</span>
          <span className="checkout-page__receipt-info-text">{decedent.name}</span>
        </div>
        <div className="checkout-page__receipt-info">
          <span className="checkout-page__receipt-info-title">{LOCALES.YEARS_OF_LIFE}</span>
          <span className="checkout-page__receipt-info-text">{deceasedYearsLife}</span>
        </div>
        <div className="checkout-page__receipt-info">
          <span className="checkout-page__receipt-info-title">{LOCALES.LOCATION}</span>
          <span className="checkout-page__receipt-info-text">{location}</span>
        </div>
      </div>
    </div>
  );
});

export default CheckoutInfo;
